/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Footer } from '../footer';
import GateWay from './gateway.component';
import SStyles from '../_shared/styles';
import { Layout } from 'antd';
import { Login, Verify, ForgotPassword, ForgotPasswordSubmit, SignUp } from '../authentication';
import { Dashboard } from '../dashboard';
import Recon from '../recon';

export default class Navigation extends Component {
  render() {
    return (
      <Router>
        <div className="App">
          <Layout css={css(SStyles.container, `background-color: white;`)}>
            <Route path="/login" component={Login} />
            <Route path="/verify" component={Verify} />
            <Route path="/forgotPassword" component={ForgotPassword} />
            <Route path="/forgotPasswordSubmit" component={ForgotPasswordSubmit} />
            <Route path="/signup" component={SignUp} />
            <Route path="/dashboard" component={Dashboard} />
            {/* Card #283 — target of the Recon Form QR code. Resolves the
                reconciliation to its GPS order and opens it for a signed-in
                user; when there is no session GateWay (below) sends the visitor
                to login carrying this path, and this page resolves nothing. */}
            <Route path="/recon/:id" component={Recon} />
          </Layout>
          <Footer />
          <GateWay />
        </div>
      </Router>
    );
  }
}
